import { checkUserSession } from "./sso";
import { nefroRequest, protectedReq } from "../helpers/requestHelper";
import { basicMsg, htmlMsg, swalMsg, valMsg } from "../helpers/swal_msg";

import { phpErrorHandler } from "../helpers/handlers/errorHandler";

import { FORM_INIT } from "../constants/form_const";

// obtener tipo de instituciones y especialidades
const getSelectData = async(setData, setItem) => {
    try {
        const resp = await protectedReq('form/get-data');
        const body = await resp.json();
        if (body.status) {
            const { specialties, institution_types, promoters } = body.resp;
            let msg = '';
            if (specialties.length <= 0)
                msg += 'Especialidades no recuperadas. ';
            if (institution_types.length <= 0)
                msg += 'Tipos de institución no recuperadas. '
            setData(e => ({
                ...e, specialties, institution_types, promoters,
                snackbar_status: { ...e, open: msg ? true : false, message: msg.trim() }
            }));
        } else {
            if (checkUserSession(body.msg, setItem))
                setData(e => ({
                    ...e, snackbar_status: {
                        ...e, open: true,
                        message: 'Incidente al obtener especialidades y tipos de institución'
                    }
                }));
        }
    } catch (err) {
        setData(e => ({
            ...e, snackbar_status: {
                ...e, open: true,
                message: 'Error al obtener especialidades y tipos de institución'
            }
        }));
    };
};

// registrar información de médico e institución(es)
const saveFormData = async(
    promotor_venta, form, institutions, setUserInfo,
    setFormValues, protectedFetchReq
) => {
    try {
        const { name, professionalID, email, phone, especialidad } = form;
        const model = {
            cedula_profesional: professionalID.trim(),
            nombre_completo: name.trim(),
            telefono_especialista: phone.trim(),
            email: email.trim().toLowerCase(),
            idEspecialidad: especialidad,
            hospitales: formatInstitutions(institutions),
            promotor_venta
        };
        const body = await protectedFetchReq('form/save', model, 'POST');
        if (body) {
            const { status, msg, resp } = body;
            if (status) {
                const txt = institutions.length > 1 ? 'instituciones' : 'institución';
                swalMsg('success', 'Formulario',
                `Se ha registrado información de médico e ${txt}`);
                setUserInfo(FORM_INIT);
                setFormValues([{
                    type: '',
                    street: '',
                    num_ext: '',
                    num_int: '',
                    postalCode: '',
                    colony: '',
                    city: '',
                    state: '',
                    schedules: {
                        sunday: {
                            enabled: true,
                            start_date: '',
                            end_date: ''
                        },
                        monday: {
                            enabled: true,
                            start_date: '',
                            end_date: ''
                        },
                        tuesday: {
                            enabled: true,
                            start_date: '',
                            end_date: ''
                        },
                        wednesday: {
                            enabled: true,
                            start_date: '',
                            end_date: ''
                        },
                        thursday: {
                            enabled: true,
                            start_date: '',
                            end_date: ''
                        },
                        friday: {
                            enabled: true,
                            start_date: '',
                            end_date: ''
                        },
                        saturday: {
                            enabled: true,
                            start_date: '',
                            end_date: ''
                        }
                    },
                    check: false
                }]);
            } else {
                if (msg === 'missing-info') {
                    let txt = '';
                    for (const e of resp.messages) {
                        txt += `<li>${e}</li>`;
                    };
                    htmlMsg('warning', 'Falta información por enviar',
                    `<div style="text-align: left; padding-left: 0pt;"><ul>${txt}</ul></div>`);
                } else if (msg === 'server-err')
                    valMsg('error', 'Formulario',
                    'Ocurrió un incidente de lado del servidor');
                else if (msg === 'php-err') {
                    valMsg('error', 'Formulario',
                    'Error al realizar la petición');
                    if (resp.err_messages && resp.err_messages.errorInfo)
                        phpErrorHandler(resp.err_messages.errorInfo);
                } else if (msg === 'missing-data')
                    basicMsg('No se ha enviado la información');
                else if (msg === 'doctor-not-saved')
                    valMsg('error', 'Operación cancelada',
                    'Médico especialista no registrado');
                else if (msg === 'multiple-errors') {
                    let txt = '';
                    for (const e of resp.err_messages) {
                        txt += `<p>${e}</p>`;
                    };
                    htmlMsg('warning', 'No se pudo realizar el registro', txt);
                } else
                    basicMsg('No se pudo completar la operación');
            }
        }
    } catch (err) {
        valMsg('error', 'Formulario',
        'Recargue la página y vuelva a intentarlo');
    };
};

const updateDoctor = async(
    form, setMedicos, handleClose, setData, protectedFetchReq
) => {
    try {
        const {
            idMedicoEspecialista, name, professionalID, email, phone,
            especialidad, promotor_name
        } = form;
        const model = {
            idMedicoEspecialista,
            cedula_profesional: professionalID.trim(),
            nombre_completo: name.trim(),
            telefono_especialista: phone.trim(),
            email: email.trim().toLowerCase(),
            idEspecialidad: especialidad,
            promotor_name
        };
        const body = await protectedFetchReq('form/doctor-update', model, 'POST');
        if (body) {
            const { status, msg, resp } = body;
            if (status) {
                setMedicos(e => e.map(
                    u => u.idMedicoEspecialista === idMedicoEspecialista ? {
                        ...u, ...form
                    } : u
                ));
                handleClose();
                setData(e => ({
                    ...e, snackbar_status: {
                        ...e, open: true,
                        message: 'Actualizado'
                    }
                }));
            } else {
                if (msg === 'doctor-not-updated')
                    basicMsg('Médico no actualizado');
                else if (['missing-info', 'missing-data'].includes(msg))
                    basicMsg('Falta información de médico');
                else if (msg === 'php-err') {
                    valMsg('error', 'Médico',
                    'Error al realizar la petición');
                    if (resp.err_messages && resp.err_messages.errorInfo)
                        phpErrorHandler(resp.err_messages.errorInfo);
                } else if (msg === 'server-err')
                    basicMsg('Error de lado de servidor');
                else if (msg === 'no-data') {}
                else
                    basicMsg('Ocurrió un incidente al actualizar médico');
            }
        }
    } catch (err) {
        basicMsg('Error al actualizar médico');
    };
};

const doctorFilter = async (model, setData, protectedFetchReq) => {
    try {
        const body = await protectedFetchReq('form/doctor-filter', model, 'POST', setData);
        if (body) {
            if (body.status) return body.resp;

            const { msg } = body;

            if (msg === 'no-data')
                setData(e => ({
                    ...e,
                    snackbar_status: {
                        ...e.snackbar_status,
                        open: true,
                        message: 'Sin médicos en el rango de fechas',
                    }
                }));
            else if (['missing-info', 'date-range-missing'].includes(msg))
                basicMsg('Falta el rango de fechas');
            else if (['php-err', 'server-err', 'req-err'].includes(msg))
                basicMsg('Error de lado de servidor');
            else
                basicMsg('Ocurrió un incidente al recuperar lista de médicos');
        }
        return [];
    } catch {
        basicMsg('Error al obtener lista de médicos');
        return [];
    };
};

const saveInstitution = async (
    institution, setDoctorInstitutions, setMedicos, setDialogStatus,
    setData, protectedFetchReq
) => {
    try {
        const model = formatNewInstitution(institution);
        const {
            idTipoHospital, idMedicoEspecialista, direccion,
        } = model
        const body = await protectedFetchReq('form/institution-save', model, 'POST', setData);
        if (body) {
            const { status, msg, resp } = body;
            if (status) {
                const {
                    idHospital, messages, new_schedules, check, postalCode
                } = resp;
                if (messages.length > 0) {
                    let txt = '';
                    for (const e of messages) {
                        txt += `<li>${e}</li>`;
                    };
                    htmlMsg('warning', 'Ocurrieron algunos errores',
                    `<div style="text-align: left; padding-left: 0pt;"><ul>${txt}</ul></div>`);
                }
                setMedicos(e => e.map(
                    a => a.idMedicoEspecialista === idMedicoEspecialista ?
                        {
                            ...a,
                            institutions: [...a.institutions, {
                                idHospital, idTipoHospital, address: direccion,
                                postalCode, check, schedules: new_schedules
                            }]
                        }
                    : a
                ));
                setDoctorInstitutions(e => ({
                    ...e, institutions: [...e.institutions, {
                        idHospital, idTipoHospital, address: direccion,
                        postalCode, check, schedules: new_schedules
                    }]
                }));
                setDialogStatus(e => ({ ...e, dialog2: true, dialog4: false }));
            } else {
                if (['missing-values', 'missing-data'].includes(msg))
                    basicMsg('Falta información');
                else if (['php-err', 'server-err', 'request-err'].includes(msg))
                    basicMsg('Error de lado de servidor');
                else
                    basicMsg('Ocurrió un incidente al registrar institución');
            }
        }
    } catch {
        basicMsg('Error al registrar institución');
    };
};

const updateInstitution = async (
    institution, setMedicos, setDialogStatus, setData, protectedFetchReq
) => {
    try {
        const model = formatSingleInstitution(institution);
        const {
            idHospital, idTipoHospital, idMedicoEspecialista, direccion,
        } = model
        const body = await protectedFetchReq('form/institution-update', model, 'POST', setData);
        if (body) {
            const { status, msg, resp } = body;
            if (status) {
                const {
                    messages, new_schedules, check, postalCode
                } = resp;
                if (messages.length > 0) {
                    let txt = '';
                    for (const e of messages) {
                        txt += `<li>${e}</li>`;
                    };
                    htmlMsg('warning', 'Ocurrieron algunos errores',
                    `<div style="text-align: left; padding-left: 0pt;"><ul>${txt}</ul></div>`);
                }
                setMedicos(e => e.map(
                    a => a.idMedicoEspecialista === idMedicoEspecialista ?
                        {
                            ...a,
                            institutions: a.institutions.map(b =>
                                b.idHospital === idHospital ?
                                    {
                                        ...b,
                                        idTipoHospital,
                                        check, postalCode,
                                        address: direccion,
                                        schedules: new_schedules
                                    }
                                : b
                            )
                        }
                    : a
                ));
                setDialogStatus(e => ({ ...e, dialog2: false, dialog3: false }));
            } else {
                if (['missing-values', 'missing-data'].includes(msg))
                    basicMsg('Falta información');
                else if (['php-err', 'server-err', 'request-err'].includes(msg))
                    basicMsg('Error de lado de servidor');
                else
                    basicMsg('Ocurrió un incidente al actualizar institución');
            }
        }
    } catch {
        basicMsg('Error al actualizar institución');
    };
};

// obtiene municipio, estado, y colonias en base al código postal
const getPostalcodeData = async(cp) => {
    try {
        const form = new FormData();
        form.append('id', cp);
        const resp = await nefroRequest('CP/', form, 'POST');
        if (Array.isArray(resp.data.data)) {
            return {
                status: true,
                resp: {
                    ...resp.data.data[0],
                    ...resp.data.data[1]
                }
            };
        } else return { status: false };
    } catch (err) {
        return { status: false };
    };
};

const formatDayAvailability = (day, DayObject) => {
    const { idDisponibilidad, enabled } = DayObject;
    if (enabled)
        return  {
            action: idDisponibilidad ? 'update' : 'insert',
            model: {
                idDisponibilidad,
                ...getAvailability(day, DayObject)
            }
        };
    return {
        action: idDisponibilidad ? 'delete': 'do-nothing',
        model: { idDisponibilidad, diaSemana: day }
    };
};

const formatNewInstitution = (institution) => {
    const {
        idTipoHospital, idMedicoEspecialista,
        street, num_ext, num_int, postalCode, colony, city, state, check,
        schedules
    } = institution;
    const { sunday, monday, tuesday, wednesday, thursday, friday, saturday } = schedules;

    let disponibilidadHorario = [];
    const num = `#${num_ext} ${num_int}`.trim();
    if (check) { // acepta visita médica
        if (sunday.enabled)
            disponibilidadHorario = [
                ...disponibilidadHorario, getAvailability('Domingo', sunday)
            ];
        if (monday.enabled)
            disponibilidadHorario = [
                ...disponibilidadHorario, getAvailability('Lunes', monday)
            ];
        if (tuesday.enabled)
            disponibilidadHorario = [
                ...disponibilidadHorario, getAvailability('Martes', tuesday)
            ];
        if (wednesday.enabled)
            disponibilidadHorario = [
                ...disponibilidadHorario, getAvailability('Miércoles', wednesday)
            ];
        if (thursday.enabled)
            disponibilidadHorario = [
                ...disponibilidadHorario, getAvailability('Jueves', thursday)
            ];
        if (friday.enabled)
            disponibilidadHorario = [
                ...disponibilidadHorario, getAvailability('Viernes', friday)
            ];
        if (saturday.enabled)
            disponibilidadHorario = [
                ...disponibilidadHorario, getAvailability('Sábado', saturday)
            ];
    }
    return {
        idTipoHospital, idMedicoEspecialista,
        direccion: `${street.trim()} ${num} CP. ${postalCode}, ${colony} ${city}, ${state}`,
        disponibilidadHorario
    };
};

const formatSingleInstitution = (institution) => {
    let to_delete = []; // areglo de ID's
    // arreglo de objetos
    let to_update = [];
    let to_insert = [];

    const {
        idHospital, idTipoHospital, idMedicoEspecialista,
        street, num_ext, num_int, postalCode, colony, city, state, check,
        schedules
    } = institution;
    const { sunday, monday, tuesday, wednesday, thursday, friday, saturday } = schedules;
    
    const num = `#${num_ext} ${num_int}`.trim();
    if (check) { // acepta visita médica
        if (sunday) {
            const { action, model } = formatDayAvailability('Domingo', sunday);
            if (action === 'insert') to_insert.push(model);
            else if (action === 'update') to_update.push(model);
            else if (action === 'delete') to_delete.push(model);
        }
        if (monday) {
            const { action, model } = formatDayAvailability('Lunes', monday);
            if (action === 'insert') to_insert.push(model);
            else if (action === 'update') to_update.push(model);
            else if (action === 'delete') to_delete.push(model);
        }
        if (tuesday) {
            const { action, model } = formatDayAvailability('Martes', tuesday);
            if (action === 'insert') to_insert.push(model);
            else if (action === 'update') to_update.push(model);
            else if (action === 'delete') to_delete.push(model);
        }
        if (wednesday) {
            const { action, model } = formatDayAvailability('Miércoles', wednesday);
            if (action === 'insert') to_insert.push(model);
            else if (action === 'update') to_update.push(model);
            else if (action === 'delete') to_delete.push(model);
        }
        if (thursday) {
            const { action, model } = formatDayAvailability('Jueves', thursday);
            if (action === 'insert') to_insert.push(model);
            else if (action === 'update') to_update.push(model);
            else if (action === 'delete') to_delete.push(model);
        }
        if (friday) {
            const { action, model } = formatDayAvailability('Viernes', friday);
            if (action === 'insert') to_insert.push(model);
            else if (action === 'update') to_update.push(model);
            else if (action === 'delete') to_delete.push(model);
        }
        if (saturday) {
            const { action, model } = formatDayAvailability('Sábado', saturday);
            if (action === 'insert') to_insert.push(model);
            else if (action === 'update') to_update.push(model);
            else if (action === 'delete') to_delete.push(model);
        }
    } else {
        if (sunday.idDisponibilidad)
            to_delete.push(sunday.idDisponibilidad);
        if (monday.idDisponibilidad)
            to_delete.push(monday.idDisponibilidad);
        if (tuesday.idDisponibilidad)
            to_delete.push(tuesday.idDisponibilidad);
        if (wednesday.idDisponibilidad)
            to_delete.push(wednesday.idDisponibilidad);
        if (thursday.idDisponibilidad)
            to_delete.push(thursday.idDisponibilidad);
        if (friday.idDisponibilidad)
            to_delete.push(friday.idDisponibilidad);
        if (saturday.idDisponibilidad)
            to_delete.push(saturday.idDisponibilidad);
    }
    return {
        idHospital, idTipoHospital, idMedicoEspecialista,
        direccion: `${street.trim()} ${num} CP. ${postalCode}, ${colony} ${city}, ${state}`,
        to_delete, to_update, to_insert, schedules
    };
};

const formatInstitutions = (institutions) => {
    return institutions.map(({
        type, street, num_ext, num_int, postalCode, colony, city, state, check,
        schedules: { sunday, monday, tuesday, wednesday, thursday, friday, saturday }
    }) => {
        let disponibilidadHorario = [];
        const num = `#${num_ext} ${num_int}`.trim();
        if (check) { // acepta visita médica
            if (sunday.enabled)
                disponibilidadHorario = [
                    ...disponibilidadHorario, getAvailability('Domingo', sunday)
                ];
            if (monday.enabled)
                disponibilidadHorario = [
                    ...disponibilidadHorario, getAvailability('Lunes', monday)
                ];
            if (tuesday.enabled)
                disponibilidadHorario = [
                    ...disponibilidadHorario, getAvailability('Martes', tuesday)
                ];
            if (wednesday.enabled)
                disponibilidadHorario = [
                    ...disponibilidadHorario, getAvailability('Miércoles', wednesday)
                ];
            if (thursday.enabled)
                disponibilidadHorario = [
                    ...disponibilidadHorario, getAvailability('Jueves', thursday)
                ];
            if (friday.enabled)
                disponibilidadHorario = [
                    ...disponibilidadHorario, getAvailability('Viernes', friday)
                ];
            if (saturday.enabled)
                disponibilidadHorario = [
                    ...disponibilidadHorario, getAvailability('Sábado', saturday)
                ];
        }
        return {
            idTipoHospital: type,
            direccion: `${street.trim()} ${num} CP. ${postalCode}, ${colony} ${city}, ${state}`,
            disponibilidadHorario
        };
    });
};

const getAvailability = (diaSemana, { start_date, end_date, start_period, end_period }) => {
    const horaInicio = `${start_date.split(":").map(
        (e, i) => i === 0 ? start_period === 'pm' ? String(Number(e) + 12) : e : e
    ).join(":")}:00`;
    const horaFin = `${end_date.split(":").map(
        (e, i) => i === 0 ? end_period === 'pm' ? String(Number(e) + 12) : e : e
    ).join(":")}:00`;
    return { diaSemana, horaInicio, horaFin };
};

export {
    getSelectData, saveFormData,
    updateDoctor, doctorFilter,
    saveInstitution,
    updateInstitution,
    getPostalcodeData
};